import Text from './PageBuilder/utilities/Text';

export default Text;
